export default "__VITE_ASSET__665e5c41__"